import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

import { ScheduleService } from 'src/app/services/schedule.service';

import { CalendarMonthComponent } from 'src/app/components/calendar/calendar-month/calendar-month.component';

import {
  CalendarEvent,
  CalendarMonthViewDay
} from 'angular-calendar';

@Component({
  selector: 'app-agenda-medico2',
  templateUrl: './agenda-medico2.component.html',
  styleUrls: ['./agenda-medico2.component.css']
})
export class AgendaMedico2Component implements OnInit {

  @Input()
  vistaProximasConsultas: boolean = false;

  @Output()
  messageEvent = new EventEmitter<any>();

  @Output()
  messageMonth = new EventEmitter<any>();

  @ViewChild(CalendarMonthComponent)
  CALENDAR: CalendarMonthComponent;

  options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };

  options_week = {
    weekday: 'long'
  };

  options_month = {
    month: 'long'
  };

  list_hours: Array<any> = [];

  events_calendar: Array<any> = [];

  hoursDay: Array<any> = [];

  daySelected: any = {};

  horas_calendar: boolean = true;

  horasAuxiliares: any[] = [];

  horasAgrupadas: any[] = [];

  horasAgrupadasAM: any[] = [];

  horasAgrupadasPM: any[] = [];

  selectedHourTabIndex: number = 0;

  dia_seleccionado: boolean = false;

  /**
   * Evita que cada recarga de horas vuelva
   * automáticamente al día actual.
   */
  private agendaInicializada: boolean = false;

  constructor(
    public scheduleService: ScheduleService,
  ) { }

  ngOnInit(): void {

    this.getHorasBloques();
  }

  /**
   * Obtiene los bloques horarios.
   */
  async getHorasBloques(
    fechaSeleccionada: any = null
  ): Promise<void> {

    await this.scheduleService
      .getScheduleTimes(fechaSeleccionada)

      .then((data: any) => {

        this.hoursDay = data || [];

      })

      .catch((error) => {

        console.error(
          'Error al obtener bloques de horas:',
          error
        );

        this.hoursDay = [];

      });
  }

  /**
   * Recibe la agenda del médico.
   *
   * IMPORTANTE:
   *
   * Primera carga:
   * usa hoy o dia_inicial.
   *
   * Cambio de mes:
   * solamente actualiza eventos.
   */
  sendToAgendaMedico(
    list_hours_doc: any,
    dia_inicial: Date = null
  ): void {

    this.list_hours =
      list_hours_doc || [];

    /**
     * Si explícitamente llega una fecha,
     * posicionamos el calendario en ella.
     */
    if (dia_inicial) {

      this.sendToCalendar(
        this.list_hours,
        dia_inicial
      );

      this.clickDiaInicial(
        dia_inicial
      );

      this.agendaInicializada = true;

      return;
    }

    /**
     * Primera carga real.
     *
     * Aquí sí podemos utilizar hoy.
     */
    if (!this.agendaInicializada) {

      const hoy = new Date();

      this.sendToCalendar(
        this.list_hours,
        hoy
      );

      this.clickDiaInicial(
        hoy
      );

      this.agendaInicializada = true;

      return;
    }

    /**
     * La agenda ya estaba abierta.
     *
     * Aquí probablemente estamos cargando
     * otro mes.
     *
     * NO enviamos dia_inicial.
     */
    this.sendToCalendar(
      this.list_hours
    );
  }

  /**
   * Convierte las horas a CalendarEvent
   * y las envía al calendario.
   */
  sendToCalendar(
    eventsX: any[],
    dia_inicial: Date = null
  ): void {

    const events_calendar:
      Array<CalendarEvent> = [];

    for (const eve of eventsX || []) {

      if (!eve.sch_date) {
        continue;
      }

      const fechaLimpia =
        eve.sch_date.substr(0, 10);

      const partes =
        fechaLimpia.split('-');

      const year =
        Number(partes[0]);

      const month =
        Number(partes[1]) - 1;

      const day =
        Number(partes[2]);

      events_calendar.push({

        start: new Date(
          year,
          month,
          day
        ),

        title: eve.sch_id,

      });
    }

    if (this.CALENDAR) {

      /**
       * Si dia_inicial es null,
       * el CalendarMonthComponent solamente
       * actualizará las horas.
       */
      this.CALENDAR.sendToCalendar(
        events_calendar,
        dia_inicial
      );
    }
  }

  /**
   * Click día calendario normal.
   */
  clickDayCalendar(
    dayCalendar: CalendarMonthViewDay
  ): void {

    this.procesarDiaSeleccionado(
      dayCalendar
    );
  }

  /**
   * Click día calendario próximas consultas.
   */
  clickDayCalendar2(
    dayCalendar: CalendarMonthViewDay
  ): void {

    this.procesarDiaSeleccionado(
      dayCalendar
    );
  }

  /**
   * Procesa día seleccionado.
   */
  async procesarDiaSeleccionado(
    dayCalendar: CalendarMonthViewDay
  ): Promise<void> {

    this.dia_seleccionado = true;

    this.horasAuxiliares = [];

    this.horasAgrupadas = [];

    this.horasAgrupadasAM = [];

    this.horasAgrupadasPM = [];

    this.selectedHourTabIndex = 0;

    this.daySelected = {};

    this.daySelected.date =
      dayCalendar.date;

    this.daySelected.dateInt =
      this.toDateInt(
        this.daySelected.date
      );

    this.daySelected.dateString =
      this.daySelected.date.toLocaleString(
        'es-US',
        this.options
      );

    this.daySelected.dayTitle =
      this.daySelected.date.toLocaleString(
        'es-US',
        this.options_week
      ) +
      ' ' +
      this.daySelected.date.getDate() +
      ' de ' +
      this.daySelected.date.toLocaleString(
        'es-US',
        this.options_month
      );

    await this.getHorasBloques(
      this.daySelected.date
    );

    const horasDelDia =
      this.getHorasDelDia(
        this.daySelected.dateInt
      );

    if (
      horasDelDia.length === 0
    ) {

      this.daySelected.available =
        false;

      this.daySelected.hours_available =
        [];

      return;
    }

    this.daySelected.available =
      true;

    this.daySelected.sch_id =
      horasDelDia[0].sch_id;

    this.daySelected.hours_available =
      this.normalizarHorasDisponibles(
        horasDelDia
      );

    this.horasAuxiliares =
      this.construirBloquesDisponibles(
        this.daySelected.hours_available
      );

    this.horasAgrupadas =
      this.groupHoursByBaseHour(
        this.horasAuxiliares
      );

    this.separarHorasAmPm();

    if (
      this.horasAuxiliares.length === 0
    ) {

      this.daySelected.available =
        false;

      this.horasAgrupadasAM = [];

      this.horasAgrupadasPM = [];

      this.selectedHourTabIndex = 0;

      return;
    }

    this.seleccionarTabInicial();
  }

  /**
   * Separa horas AM y PM.
   */
  private separarHorasAmPm(): void {

    const horasAM =
      this.horasAuxiliares.filter(
        hour =>
          this.getHourNumber(
            hour.from
          ) < 12
      );

    const horasPM =
      this.horasAuxiliares.filter(
        hour =>
          this.getHourNumber(
            hour.from
          ) >= 12
      );

    this.horasAgrupadasAM =
      this.groupHoursByBaseHour(
        horasAM
      );

    this.horasAgrupadasPM =
      this.groupHoursByBaseHour(
        horasPM
      );
  }

  /**
   * Selecciona inicialmente AM o PM.
   */
  private seleccionarTabInicial(): void {

    const hoyInt =
      this.toDateInt(
        new Date()
      );

    const esFechaFutura =
      this.daySelected?.dateInt >
      hoyInt;

    if (esFechaFutura) {

      this.selectedHourTabIndex = 0;

      return;
    }

    const existenHorasAM =
      this.horasAgrupadasAM?.some(
        group =>
          group.hours?.length > 0
      );

    this.selectedHourTabIndex =
      existenHorasAM ? 0 : 1;
  }

  /**
   * Obtiene hora numérica.
   */
  private getHourNumber(
    hour: string
  ): number {

    if (!hour) {
      return 0;
    }

    return Number(
      hour.substring(0, 2)
    );
  }

  /**
   * Obtiene las horas pertenecientes
   * al día seleccionado.
   */
  private getHorasDelDia(
    dateInt: number
  ): any[] {

    return (
      this.list_hours || []
    ).filter((hour) => {

      if (!hour.sch_date) {
        return false;
      }

      return (
        this.getDateIntFromSchDate(
          hour.sch_date
        ) === dateInt
      );
    });
  }

  /**
   * Normaliza las horas disponibles.
   */
  private normalizarHorasDisponibles(
    horasDelDia: any[]
  ): any[] {

    const hoursX = [];

    for (
      const hour of horasDelDia
    ) {

      if (hour.hours) {

        for (
          const xx of hour.hours
        ) {

          hoursX.push({

            sch_hou_id: xx.id,

            sch_hou_from: xx.from,

            sch_hou_to: xx.to,

            sch_sta_id: xx.sta_id,

            is_ondemand:
              xx.is_ondemand || false

          });
        }

      } else {

        hoursX.push({

          sch_hou_id:
            hour.sch_hou_id,

          sch_hou_from:
            hour.sch_hou_from,

          sch_hou_to:
            hour.sch_hou_to,

          sch_sta_id:
            hour.sch_sta_id,

          is_ondemand:
            hour.is_ondemand || false

        });
      }
    }

    return hoursX;
  }

  /**
   * Construye bloques disponibles.
   */
  private construirBloquesDisponibles(
    hoursAvailable: any[]
  ): any[] {

    const bloques = [];

    for (
      const baseBlock of
      this.hoursDay || []
    ) {

      const block = {
        ...baseBlock
      };

      block.available = false;

      block.sch_hou_id = null;

      block.existe = false;

      block.hour_number =
        Number(
          block.from.replaceAll(
            ':',
            ''
          )
        );

      block.sta_id = null;

      block.is_ondemand = false;

      for (
        const hour of
        hoursAvailable
      ) {

        if (
          block.from ===
          hour.sch_hou_from
        ) {

          block.available =
            hour.sch_sta_id
              ? hour.sch_sta_id === 21
              : true;

          block.existe = true;

          block.sta_id =
            hour.sch_sta_id;

          block.is_ondemand =
            !!hour.is_ondemand;

          block.sch_hou_id =
            hour.sch_hou_id;

          bloques.push({
            ...block
          });
        }
      }
    }

    return bloques;
  }

  /**
   * Click sobre una hora.
   */
  clickHour(
    hora: any
  ): void {

    this.messageEvent.emit({

      day: this.daySelected,

      hour: hora

    });
  }

  /**
   * Cambio de mes.
   */
  clickMonthCalendar(
    data: any
  ): void {

    /**
     * Limpiamos el día anterior.
     */
    this.dia_seleccionado = false;

    this.daySelected = {};

    this.horasAuxiliares = [];

    this.horasAgrupadas = [];

    this.horasAgrupadasAM = [];

    this.horasAgrupadasPM = [];

    this.selectedHourTabIndex = 0;

    /**
     * El padre deberá solicitar
     * las horas del nuevo mes.
     */
    this.messageMonth.emit(data);
  }

  /**
   * Selección inicial.
   */
  clickDiaInicial(
    dia: Date
  ): void {

    const toDayCalendar:
      CalendarMonthViewDay = {

      badgeTotal: 1,

      cssClass:
        'amc-cal-day-selected',

      date: dia,

      day: dia.getDay(),

      events: [],

      inMonth: true,

      isFuture: false,

      isPast: false,

      isToday: true,

      isWeekend: false,

    };

    this.procesarDiaSeleccionado(
      toDayCalendar
    );
  }

  /**
   * Convierte Date a YYYYMMDD.
   */
  private toDateInt(
    date: Date
  ): number {

    return (
      date.getFullYear() * 10000 +
      (date.getMonth() + 1) * 100 +
      date.getDate()
    );
  }

  /**
   * Convierte sch_date a YYYYMMDD.
   */
  private getDateIntFromSchDate(
    schDate: string
  ): number {

    const cleanDate =
      schDate.substr(0, 10);

    const parts =
      cleanDate.split('-');

    const year =
      Number(parts[0]);

    const month =
      Number(parts[1]);

    const day =
      Number(parts[2]);

    return (
      year * 10000 +
      month * 100 +
      day
    );
  }

  /**
   * Agrupa horas por hora base.
   */
  groupHoursByBaseHour(
    hours: any[]
  ): any[] {

    const grouped = {};

    hours.forEach(
      (itemHour) => {

        const block =
          itemHour.from.substring(
            0,
            2
          );

        if (!grouped[block]) {
          grouped[block] = [];
        }

        grouped[block].push(
          itemHour
        );
      }
    );

    return Object.keys(grouped)

      .sort()

      .map(key => ({

        block: key,

        hours:
          grouped[key].sort(
            (a, b) =>
              a.hour_number -
              b.hour_number
          )

      }));
  }

}